export const stationAPI = null;
// const KQUAKE_API_BASE_URL = "http://211.188.65.126:8092/api/v1/";
const KQUAKE_API_BASE_URL = "https://quake.kigam.re.kr/api/v1/";
// const KQUAKE_ESMDB_BASE_URL = 'http://211.188.65.126:8091/esmdb/v1/'
const KQUAKE_ESMDB_BASE_URL = "https://quake.kigam.re.kr/esmdb/v1/";

class ApiCallError extends Error {
  constructor(message, httpStatus, ...params) {
    super(message, ...params);
    this.httpStatus = httpStatus;
    this.name = "ApiCallError";
  }
}

export const getEvents = async (queryParam) => {
  const endpoint = KQUAKE_API_BASE_URL + "events/";
  const config = { method: "GET" };
  const queryString = "?" + new URLSearchParams(queryParam).toString();

  let response = {};
  try {
    response = await window.fetch(endpoint + queryString, config);
  } catch (error) {
    throw new ApiCallError(error.message, null, { cause: error });
  }
  if (response.status === 200) {
    try {
      return await response.json();
    } catch (error) {
      throw new ApiCallError(error.message, response.status, { cause: error });
    }
  }
  throw new ApiCallError(response.statusText, response.status);
};

export const getEventsByCatalog = async (catalog) => {
  const endpoint = KQUAKE_API_BASE_URL + `events/${catalog}`;
  const config = { method: "GET" };

  let response = {};
  try {
    response = await window.fetch(endpoint, config);
  } catch (error) {
    throw new ApiCallError(error.message, null, { cause: error });
  }
  if (response.status === 200) {
    try {
      return await response.json();
    } catch (error) {
      throw new ApiCallError(error.message, response.status, { cause: error });
    }
  }
  throw new ApiCallError(response.statusText, response.status);
};

export const getHistoricalEvents = async (queryParam) => {
  const endpoint = KQUAKE_API_BASE_URL + `events/historical`;
  const config = { method: "GET" };
  const queryString = "?" + new URLSearchParams(queryParam).toString();

  let response = {};
  try {
    response = await window.fetch(endpoint + queryString, config);
  } catch (error) {
    throw new ApiCallError(error.message, null, { cause: error });
  }
  if (response.status === 200) {
    try {
      return await response.json();
    } catch (error) {
      throw new ApiCallError(error.message, response.status, { cause: error });
    }
  }
  throw new ApiCallError(response.statusText, response.status);
};

export const getStations = async () => {
  const endpoint = KQUAKE_API_BASE_URL + "stations/";
  const headers = { "Content-Type": "application/json" };
  const config = {
    method: "GET",
    headers: {
      ...headers,
    },
  };

  let data;
  try {
    const response = await window.fetch(endpoint, config);
    if (response.status === 200) {
      data = await response.json();
      return data;
    }
    throw new Error(response.status);
  } catch (err) {
    // return Promise.reject(err.message ? err.message : data)
    throw new Error(err.message ? err.message : err);
  }
};

export const getEventRecords = async (queryParam) => {
  // const endpoint = KQUAKE_API_BASE_URL + 'event-records/'
  const endpoint = KQUAKE_ESMDB_BASE_URL + "records/";
  const config = { method: "GET" };
  const queryString = "?" + new URLSearchParams(queryParam).toString();

  let response = {};
  try {
    response = await window.fetch(endpoint + queryString, config);
  } catch (error) {
    throw new ApiCallError(error.message, null, { cause: error });
  }
  if (response.status === 200) {
    try {
      return await response.json();
    } catch (error) {
      throw new ApiCallError(error.message, response.status, { cause: error });
    }
  }
  throw new ApiCallError(response.statusText, response.status);
};

export const getEventRecordData = async (recordId, dataTypes) => {
  const endpoint = `${KQUAKE_ESMDB_BASE_URL}records/${recordId}/data/`;
  const config = { method: "GET" };
  let queryString =
    "?" + dataTypes.map((dataType) => `type=${dataType}`).join("&");

  let response = {};
  try {
    response = await window.fetch(endpoint + queryString, config);
  } catch (error) {
    throw new ApiCallError(error.message, null, { cause: error });
  }
  if (response.status === 200) {
    try {
      return await response.json();
    } catch (error) {
      throw new ApiCallError(error.message, response.status, { cause: error });
    }
  }
  throw new ApiCallError(response.statusText, response.status);
};

export const processEventRecordData = async (
  recordId,
  processParameters,
  purpose,
  apiToken
) => {
  const endpoint = `${KQUAKE_ESMDB_BASE_URL}records/${recordId}/data/`;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Web-Auth-Token": apiToken,
    },
    body: JSON.stringify({ params: processParameters, purpose }),
  };

  let response = {};
  try {
    response = await window.fetch(endpoint, config);
  } catch (error) {
    throw new ApiCallError(error.message, null, { cause: error });
  }
  if (response.status === 200) {
    try {
      return await response.json();
    } catch (error) {
      throw new ApiCallError(error.message, response.status, { cause: error });
    }
  }
  throw new ApiCallError(response.statusText, response.status);
};

export const getNotices = async () => {
  const endpoint = KQUAKE_API_BASE_URL + "--notices/";
  const headers = { "Content-Type": "application/json" };
  const config = {
    method: "GET",
    headers: {
      ...headers,
    },
  };

  try {
    const response = await window.fetch(endpoint, config);
    if (response.status !== 200) {
      throw new Error(response.status);
    }
    const data = await response.json();
    return data;
  } catch (err) {
    // return Promise.reject(err.message ? err.message : '')
    throw err;
  }
};

export const downloadRawEventData = async (eventdataPath, apiToken) => {
  if (eventdataPath.length === 0) {
    // throw new Error('eventRecordIds is empty.')
    return {
      ok: true,
      status: 204,
    };
  }

  const endpoint = KQUAKE_API_BASE_URL + "download/direct/" + eventdataPath;
  const config = {
    method: "GET",
    headers: {
      "X-Web-Auth-Token": apiToken,
    },
  };

  try {
    return await window.fetch(endpoint, config);
  } catch (error) {
    return {
      ok: false,
      statusText: error.message,
    };
  }
};

export const downloadFilteredEventRecord = async (
  type,
  contents,
  format,
  purpose,
  eventRecordIds,
  apiToken
) => {
  if (eventRecordIds.length === 0) {
    // throw new Error('eventRecordIds is empty.')
    return {
      ok: true,
      status: 204,
    };
  }

  // const endpoint = KQUAKE_API_BASE_URL + 'download/query'
  const endpoint = KQUAKE_ESMDB_BASE_URL + "records/data/";
  const config = {
    method: "GET",
    headers: {
      "X-Web-Auth-Token": apiToken,
    },
  };
  let queryString =
    "?" +
    new URLSearchParams({
      type,
      format,
      purpose,
      id: eventRecordIds.join(","),
    }).toString();

  if (contents && contents.length > 0) {
    contents.forEach((c) => (queryString += `&content=${c}`));
  }

  try {
    return await window.fetch(endpoint + queryString, config);
  } catch (error) {
    return {
      ok: false,
      statusText: error.message,
    };
  }
};

export const downloadAnnualReport = async (year, apiToken) => {
  const endpoint = KQUAKE_API_BASE_URL + "download/annualreports/" + year;
  const config = {
    method: "GET",
    headers: {
      "X-Web-Auth-Token": apiToken,
    },
  };

  try {
    return await window.fetch(endpoint, config);
  } catch (error) {
    return {
      ok: false,
      statusText: error.message,
    };
  }
};

export const getGeoData = async () => {
  console.log("## getGeoData ##");
  let response = {};
  try {
    response = await window.fetch(KQUAKE_API_BASE_URL + "geodata/v1-0");
  } catch (error) {
    throw new ApiCallError(error.message, null, { cause: error });
  }
  if (response.status === 200) {
    try {
      return await response.json();
    } catch (error) {
      throw new ApiCallError(error.message, response.status, { cause: error });
    }
  }
  throw new ApiCallError(response.statusText, response.status);
};
